import useSWR from "swr";
import API from "../../utils/api";
import { getPersistData } from "../../app/hooks/persist";
import { useToken } from "app/hooks";

const KEY = "/filter?type="; // (1) 필터 목록 조회

let swrData: any = getPersistData(KEY);

export function useFilterList(type, Customer?) {
	const { data: token } = useToken();
	const { data, mutate } = useSWR<any>(
		Customer === "customer" ? KEY + type + "&branchId=1" : KEY + type,
		async () => {
			let url = Customer === "customer" ? KEY + type + "&branchId=1" : KEY + type;

			const response = await API.get(url, token + "", {});
			swrData = response.result?.result?.list;

			return swrData;
		},
		{ revalidateOnFocus: true }
	);

	// ccl이 아닌 새로운 CRM 의 경우 본사 id 에 해당하는 1 값을 사용하지 않으므로 제거.
	// DB에는 default 라고 정의해두었음.
	if (type == "branch" && !process.env.REACT_APP_API_URL?.includes("ccl")) {
		return {
			filterList: (data ?? []).filter((v) => v.id != 1),
			mutate: (value?: any) => {
				if (value != undefined) {
					swrData = value;
				}
				return mutate();
			},
		};
	}

	return {
		filterList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value;
			}
			return mutate();
		},
	};
}
